"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfigContext = exports.defaultConfig = void 0;

var _react = require("react");

var _linkRenderer = _interopRequireDefault(require("./linkRenderer"));

var _theme = _interopRequireDefault(require("./theme"));

var _translations = _interopRequireDefault(require("./translations"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultConfig = {
  // This is overridden with a proper implementation in ../index.tsx
  getPortalsRootElement: function getPortalsRootElement() {
    // eslint-disable-next-line no-console
    console.error('"getPortalsRootElement" can only be used if called in a component tree wrapped by "ConfigProvider".');
    return null;
  },
  createPortal: function createPortal() {
    // eslint-disable-next-line no-console
    console.warn('"createPortal" can only be used if called in a component tree wrapped by "ConfigProvider".');
    return null;
  },
  linkRenderer: _linkRenderer.default,
  portalsRoot: 'body',
  theme: _theme.default,
  translations: _translations.default
};
exports.defaultConfig = defaultConfig;
var ConfigContext = (0, _react.createContext)(defaultConfig);
exports.ConfigContext = ConfigContext;